import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { DAYS_OF_WEEK } from 'owa-recurrence-types';

const DEFAULT_WEEK_START_DAY = 1;

export default function (): string[] {
    let weekStartDay: number = DEFAULT_WEEK_START_DAY;
    let userConfiguration = getUserConfiguration();
    if (
        userConfiguration &&
        userConfiguration.UserOptions.WeekStartDay >= 0 &&
        userConfiguration.UserOptions.WeekStartDay < 7
    ) {
        weekStartDay = userConfiguration.UserOptions.WeekStartDay;
    }
    let firstDayOfTheWeek = DAYS_OF_WEEK[weekStartDay];

    let count = DAYS_OF_WEEK.indexOf(firstDayOfTheWeek);
    let daysOfWeek = DAYS_OF_WEEK.slice(0);
    // Rotate the days in week according to user settings
    count -= daysOfWeek.length * Math.floor(count / daysOfWeek.length);
    daysOfWeek.push.apply(daysOfWeek, daysOfWeek.splice(0, count));

    return daysOfWeek;
}
